import { siDiscord } from 'simple-icons';

export default function DiscordIcon({ className = '', ...props }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Discord"
      focusable="false"
      {...props}
    >
      <path fill="currentColor" d={siDiscord.path} />
    </svg>
  );
}
